import React from "react";
import { styled } from "@linaria/react";
import { SCREEN_SIZE } from "@static/screen-size";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { removeNotification } from "@redux/slices/SHIELD_STARTER/step1Slice";

export enum ToastTypes {
  ERROR = "error",
  INFO = "info",
}

const ToastContainer = styled.div`
  position: fixed;
  bottom: 64px;
  right: 24px;
  width: 530px;
  z-index: 101;

  @media screen and (max-width: ${SCREEN_SIZE.mobilesUp}px) {
    width: unset;
    padding: 0 24px;
    right: inherit;
  }
`;

const ToastMessage = styled.div<{ type: string }>`
  display: flex;
  flex-direction: row;
  position: relative;
  margin-bottom: 15px;
  background:  ${({type}) => type === ToastTypes.ERROR ? "#ffe9ec" : "#f5f5f5"};

  box-shadow: 0px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 24px;
  border-left: ${(props) =>
    props.type === ToastTypes.ERROR
      ? " 6px solid #C50000"
      : " 6px solid #434343"};
  overflow: hidden;

  & .message {
    display: flex;
    margin: 0 20px;
    flex: 1;
  }

  & .toast .close {
    position: absolute;
    top: 10px;
    right: 15px;
    padding: 5px;
    cursor: pointer;
    opacity: 0.7;
  }

  & .toast .close:hover {
    opacity: 1;
  }
`;

const TextContainer = styled.div<{ type: string }>`
  font-size: 14px;
  display: flex;
  margin: 0 20px;
  flex: 1;
  color: ${(props) =>
    props.type === ToastTypes.ERROR ? "#C50000" : "#434343"};

  span {
    font-weight: 600;
  }
`;

function Toast() {
  const dispatch = useAvivaDispatch();
  const notifications = useAvivaSelector(
    (state) => state.shieldStarterStep1.notifications
  );

  return (
    <ToastContainer id="toast">
      {notifications &&
        notifications.map((notification) => (
          <ToastMessage type={notification.type || ToastTypes.INFO}>
            <div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                  fill={
                    notification.type === ToastTypes.ERROR
                      ? "#C50000"
                      : "#434343"
                  }
                />
                <path
                  d="M12.525 15.5006L12.9501 6.99875C12.9772 6.45541 12.544 6 12 6C11.456 6 11.0228 6.45542 11.0499 6.99875L11.475 15.5006C11.489 15.7804 11.7199 16 12 16C12.2801 16 12.511 15.7804 12.525 15.5006Z"
                  fill={
                    notification.type === ToastTypes.ERROR
                      ? "#C50000"
                      : "#434343"
                  }
                />
                <circle
                  cx="12"
                  cy="18"
                  r="1"
                  fill={
                    notification.type === ToastTypes.ERROR
                      ? "#C50000"
                      : "#434343"
                  }
                />
              </svg>
            </div>
            <TextContainer type={notification.type || ToastTypes.INFO}>
              <p>
                <span>{notification.title}</span> {notification.description}
              </p>
            </TextContainer>
            <div
              onClick={() => {
                dispatch(removeNotification(notification));
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.46967 0.46967C0.762563 0.176777 1.23744 0.176777 1.53033 0.46967L13.5303 12.4697C13.8232 12.7626 13.8232 13.2374 13.5303 13.5303C13.2374 13.8232 12.7626 13.8232 12.4697 13.5303L0.46967 1.53033C0.176777 1.23744 0.176777 0.762563 0.46967 0.46967Z"
                  fill="#434343"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.5303 0.46967C13.8232 0.762563 13.8232 1.23744 13.5303 1.53033L1.53033 13.5303C1.23744 13.8232 0.762563 13.8232 0.46967 13.5303C0.176777 13.2374 0.176777 12.7626 0.46967 12.4697L12.4697 0.46967C12.7626 0.176777 13.2374 0.176777 13.5303 0.46967Z"
                  fill="#434343"
                />
              </svg>
            </div>
          </ToastMessage>
        ))}
    </ToastContainer>
  );
}

export default Toast;
